import { render, staticRenderFns } from "./DA.vue?vue&type=template&id=675c56c6&"
import script from "./DA.vue?vue&type=script&lang=js&"
export * from "./DA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('675c56c6')) {
      api.createRecord('675c56c6', component.options)
    } else {
      api.reload('675c56c6', component.options)
    }
    module.hot.accept("./DA.vue?vue&type=template&id=675c56c6&", function () {
      api.rerender('675c56c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/empresas/69080200-7/DA.vue"
export default component.exports